export default __webpack_public_path__ + "static/media/No.1-1.3bdc80ca.jpg";